module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well kittens"
  }, [_c('img', {
    attrs: {
      "src": _vm.catimgsrc
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-598adc20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KittensComponent.vue
// module id = 51
// module chunks = 2